<template>
  <div v-if="isEditing && isAnchorOnly" class="my-5 h-5">
    <div class="bk-anchor-indicator container">
      <div class="bk-anchor-pill">
        {{ anchorTitle || title }}
        <div><SpriteSymbol name="anchor" /></div>
      </div>
    </div>
  </div>
  <div
    v-else-if="!isAnchorOnly"
    :id="anchorId"
    :class="{
      'container paragraph-title mb-spacing-base mt-spacing-lg': !parentType,
      'opacity-20': isEditing && isAnchorOnly,
    }"
    class=""
  >
    <div class="max-w-screen-desktop">
      <h2 class="title is-h3 relative text-balance">
        <span v-blokkli-editable:field_title>{{ title }}</span>
        <div v-if="isEditing && anchorId" class="bk-anchor-pill">
          {{ anchorTitle || title }}
          <div><SpriteSymbol name="anchor" /></div>
        </div>
      </h2>

      <p
        v-if="subtitle"
        v-blokkli-editable:field_text
        class="subtitle is-h4 text-balance"
      >
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTitleFragment } from '#graphql-operations'
import { toValidHtmlId } from '~/helpers'

const props = defineProps<ParagraphTitleFragment>()

const { parentType, options, uuid, isEditing } = defineBlokkli({
  bundle: 'title',
  globalOptions: ['showAnchor', 'bkHiddenGlobally', 'publicationChannels'],
  options: {
    anchorOnly: {
      type: 'checkbox',
      label: 'Nur in Anker anzeigen',
      default: false,
      group: 'Advanced',
    },
  },
  editor: {
    previewWidth: 800,
    determineVisibleOptions(ctx) {
      if (ctx.options.showAnchor) {
        return [
          'showAnchor',
          'anchorOnly',
          'bkHiddenGlobally',
          'publicationChannels',
        ]
      }
      return ['showAnchor', 'bkHiddenGlobally', 'publicationChannels']
    },
  },
})

const anchorId = computed<string | undefined>(() => {
  if (!options.value.showAnchor) {
    return undefined
  }

  const id = props.anchorTitle || props.title || uuid
  return toValidHtmlId(id)
})

const isAnchorOnly = computed(
  () => options.value.showAnchor && options.value.anchorOnly,
)
</script>
